<div *ngIf="assetData">
  <!--Product Type Vehicle-->

  <div
    style="display: flex; flex-direction: column"
    class="grid-container-main"
    *ngIf="assetData['Product_Category'] === 'Vehicle Loan'"
  >
    <div
      class="grid-container"
      *ngIf="assetData['Product_Category'] === 'Vehicle Loan'"
    >
      <div class="grid-item">
        <div class="grid-sub-item">Customer Name:</div>
        <div class="grid-sub-item-value">{{ assetData["CustomerName"] }}</div>
      </div>

      <div class="grid-item">
        <div class="grid-sub-item">Vehicle Type :</div>
        <div class="grid-sub-item-value">{{ assetData["Vehicle_Type"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Vehicle SubType :</div>
        <div class="grid-sub-item-value">
          {{ assetData["Vehicle_SubType"] }}
        </div>
      </div>

      <div class="grid-item">
        <div class="grid-sub-item">Vehicle Model :</div>
        <div class="grid-sub-item-value">
          {{ assetData["VehicleModel_Name"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Vehicle Manufacturer :</div>
        <div class="grid-sub-item-value">
          {{ assetData["VehicleManufactureName"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Vehicle Category :</div>
        <div class="grid-sub-item-value">
          {{ assetData["VehicleCategoryName"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Variant :</div>
        <div class="grid-sub-item-value">{{ assetData["Variant"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Vehicle Registation No :</div>
        <div class="grid-sub-item-value">
          {{ assetData["VehicleRegistationNo"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Manufacturing Year :</div>
        <div class="grid-sub-item-value">{{ assetData["MefgYear"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Registation Date :</div>
        <div class="grid-sub-item-value">
          {{ assetData["RegistationDate"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">FuelType :</div>
        <div class="grid-sub-item-value">{{ assetData["FuelType"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Color :</div>
        <div class="grid-sub-item-value">{{ assetData["Color"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Registation Expiry Date :</div>
        <div class="grid-sub-item-value">
          {{ assetData["RegistationExpiryDate"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Engine No :</div>
        <div class="grid-sub-item-value">{{ assetData["EngineNo"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Chassis No :</div>
        <div class="grid-sub-item-value">{{ assetData["ChassisNo"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Vehicle Cost :</div>
        <div class="grid-sub-item-value">{{ assetData["VehicleCost"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Dealer Name :</div>
        <div class="grid-sub-item-value">{{ assetData["DealorName"] }}</div>
      </div>   
    </div>

    <div *ngIf="assetData['Product_Category'] === 'Vehicle Loan' && AssetsAttachment?.length">
      <div class="mt-3 p-3 bg-light rounded border">
        <div class="font-weight-bold text-uppercase text-dark mb-2 font-size-12" style="letter-spacing: 0.5px;">
          <i class="fas fa-paperclip text-primary mr-1"></i> Asset Attachments
        </div>
        <div class="d-flex flex-column" style="gap: 0.5rem;">
          <div *ngFor="let report of AssetsAttachment; let i = index" class="d-flex align-items-center justify-content-between p-2 bg-white rounded border" style="gap: 0.5rem;">
            <div class="d-flex align-items-center min-w-0" style="flex: 1; min-width: 0;">
              <span class="badge badge-primary mr-2">{{ i + 1 }}</span>
              <span class="font-weight-bold text-dark mr-2 font-size-12 text-truncate" style="max-width: 100px;" *ngIf="report.Title">{{ report.Title }}:</span>
              <span class="text-truncate text-muted font-size-12" style="flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" [title]="report.Doc_Path">
                {{ report.Doc_Path }}
              </span>
            </div>
            <a *ngIf="report.Doc_Path" [href]="Doc_Path + ApplicationNumber + '/' + report.Doc_Path" target="_blank" class="btn btn-sm btn-outline-primary py-1 px-2 font-size-11 flex-shrink-0" style="white-space: nowrap;">
              <i class="fas fa-paperclip mr-1"></i> View
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Product type Property Info-->

  <div
    style="display: flex; flex-direction: column"
    class="grid-container-main"
    *ngIf="assetData['Product_Category'] === 'Property Loan'"
  >
    <div
      class="grid-container"
      *ngIf="assetData['Product_Category'] === 'Property Loan'"
    >
      <div class="grid-item">
        <div class="grid-sub-item">Customer Name:</div>
        <div class="grid-sub-item-value">{{ assetData["CustomerName"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Type of Property :</div>
        <div class="grid-sub-item-value">
          {{ assetData["TypeofProperty_Name"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Nature of Property :</div>
        <div class="grid-sub-item-value">
          {{ assetData["NatureofProperty_Name"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Ownership Type :</div>
        <div class="grid-sub-item-value">
          {{ assetData["OwnershipType_Name"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Ownership Document :</div>
        <div class="grid-sub-item-value">
          {{ assetData["OwnershipDocument_Name"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Unit of Measurement :</div>
        <div class="grid-sub-item-value">
          {{ assetData["UnitofMeasurement"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Address :</div>
        <div class="grid-sub-item-value">{{ assetData["Address"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">TotalArea :</div>
        <div class="grid-sub-item-value">{{ assetData["TotalArea"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Constructed Area :</div>
        <div class="grid-sub-item-value">
          {{ assetData["ConstructedArea"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Type of Mortgage :</div>
        <div class="grid-sub-item-value">{{ assetData["TypeofMortgage"] }}</div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">Mortgage Singed By :</div>
        <div class="grid-sub-item-value">
          {{ assetData["MortgageSingedByName"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">CERSAI No :</div>
        <div class="grid-sub-item-value">
          {{ assetData["Cersai_No"] }}
        </div>
      </div>
      <div class="grid-item">
        <div class="grid-sub-item">GeoLocation :</div>
        <div class="grid-sub-item-value">{{ assetData["GeoLocation"] }}</div>
      </div>
    </div>
    <div *ngIf="assetData['Product_Category'] === 'Property Loan' && AssetsAttachment?.length">
      <div class="mt-3 p-3 bg-light rounded border" style="width: 100%; box-sizing: border-box;">
        <div class="font-weight-bold text-uppercase text-dark mb-2 font-size-12" style="letter-spacing: 0.5px;">
          <i class="fas fa-paperclip text-primary mr-1"></i> Property Attachments
        </div>
        <div class="d-flex flex-column" style="gap: 0.5rem; width: 100%;">
          <div *ngFor="let report of AssetsAttachment; let i = index" class="d-flex align-items-center justify-content-between p-2 bg-white rounded border" style="gap: 0.5rem; width: 100%; box-sizing: border-box; overflow: hidden;">
            <div class="d-flex align-items-center min-w-0" style="flex: 1; min-width: 0; overflow: hidden;">
              <span class="badge badge-primary mr-2 flex-shrink-0">{{ i + 1 }}</span>
              <span class="font-weight-bold text-dark mr-2 font-size-12 text-truncate flex-shrink-0" style="max-width: 100px;" *ngIf="report.Title">{{ report.Title }}:</span>
              <span class="text-truncate text-muted font-size-12" style="flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" [title]="report.Doc_Path">
                {{ report.Doc_Path }}
              </span>
            </div>
            <a *ngIf="report.Doc_Path" [href]="docBaseUrl + (ApplicationNumber?.Application_No || ApplicationNumber) + '/' + report.Doc_Path" target="_blank" class="btn btn-sm btn-outline-primary py-1 px-2 font-size-11 flex-shrink-0 ml-2" style="white-space: nowrap;">
              <i class="fas fa-paperclip mr-1"></i> View
            </a>
          </div>
        </div>
      </div>
    </div>

    <div
      style="display: flex; flex-direction: column; align-items: center ; padding-left: 0%"
      class="table-responsive"
      *ngIf="jsonDataForGold.data > 0"
    >
      <div class="table-responsive mt-4 mb-4" style="width: 98%" *ngIf="jsonDataForGold">
        <mat-table [dataSource]="jsonDataForGold">
          <ng-container matColumnDef="Id">
            <mat-header-cell
              class="grid-header"
              style="max-width: 3.125rem"
              *matHeaderCellDef
            >
              #
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row; let i = index"
              class="grid-cell"
              style="max-width: 3.125rem; max-height: 0.3125rem"
            >
              {{ i + 1 }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ItemName">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Item Name</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.ItemName }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ItemType">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Item Type</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.ItemType }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Qty">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Qty</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Qty }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="PurityCT">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Purity CT</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.PurityCT }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="GrossWt">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Gross Wt</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.GrossWt }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="StoneWt">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Stone Wt</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.StoneWt }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="OtherWt">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Other Wt</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.OtherWt }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="NetWt">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Net Wt</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.NetWt }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="PureWt">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Pure Wt</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{
                ((row.NetWt * (row.PurityCT * fixrate24ct)) / 100).toFixed(2)
              }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ValulationRate_PerCT">
            <mat-header-cell class="grid-header" *matHeaderCellDef
              >Rate</mat-header-cell
            >
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.ValulationRate_PerCT }}
            </mat-cell>
          </ng-container>

          <mat-header-row
            *matHeaderRowDef="displayedAssetItemColumns"
          ></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedAssetItemColumns"
          ></mat-row>
        </mat-table>

        <div class="row m-0 mt-4" *ngIf="assetTotal">
          <div class="col-md-3 p-1"><B>Total Qty:</B> {{ assetTotal.Qty }}</div>
          <div class="col-md-3 p-1">
            <B>Total Gross Wt:</B> {{ assetTotal.GrossWt }}
          </div>
          <div class="col-md-3 p-1">
            <B>Total Stone Wt:</B> {{ assetTotal.StoneWt }}
          </div>
          <div class="col-md-3 p-1">
            <B>Total Net Wt:</B> {{ assetTotal.NetWt }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- start: common valuation and legal details -->
  <div
    class="process-section-wrap"
    *ngIf="
      (valuationProcessCards && valuationProcessCards.length > 0) ||
      (legalProcessCards && legalProcessCards.length > 0)
    "
  >
    <div
      class="process-card"
      *ngIf="valuationProcessCards && valuationProcessCards.length > 0"
    >
      <div class="process-title">Valuation Details</div>
      <div class="process-card-grid">
        <div
          class="process-record"
          *ngFor="let val of valuationProcessCards; let i = index"
        >
          <div class="process-record-head">#{{ i + 1 }}</div>
          <div class="process-grid">
            <div class="grid-item" *ngIf="val['ValuationDate']">
              <div class="grid-sub-item">Valuation Date :</div>
              <div class="grid-sub-item-value">{{ val["ValuationDate"] }}</div>
            </div>
            <div class="grid-item" *ngIf="val['Valuation_Type']">
              <div class="grid-sub-item">Valuation Type :</div>
              <div class="grid-sub-item-value">{{ val["Valuation_Type"] }}</div>
            </div>
            <div class="grid-item" *ngIf="val['Valuation_Amount']">
              <div class="grid-sub-item">Amount :</div>
              <div class="grid-sub-item-value">{{ val["Valuation_Amount"] }}</div>
            </div>
            <div class="grid-item" *ngIf="val['Valuation_Type2']">
              <div class="grid-sub-item">Valuation Type 2 :</div>
              <div class="grid-sub-item-value">{{ val["Valuation_Type2"] }}</div>
            </div>
            <div class="grid-item" *ngIf="val['Valuation_Amount2']">
              <div class="grid-sub-item">Valuation Amount 2 :</div>
              <div class="grid-sub-item-value">{{ val["Valuation_Amount2"] }}</div>
            </div>
            <div class="grid-item" *ngIf="val['ValuationDoneBy']">
              <div class="grid-sub-item">Valuation Done By :</div>
              <div class="grid-sub-item-value">{{ val["ValuationDoneBy"] }}</div>
            </div>
            <div class="grid-item process-remark" *ngIf="val['Process_Remark']">
              <div class="grid-sub-item">Remark :</div>
              <div class="grid-sub-item-value">{{ val["Process_Remark"] }}</div>
            </div>
          </div>
          <div
            class="process-attachments"
            *ngIf="val.attachments && val.attachments.length > 0"
          >
            <div class="process-attachments-title">Attachments</div>
            <div class="attachment-list">
              <ng-container *ngFor="let doc of val.attachments">
                <a
                  class="attachment-chip"
                  href="{{ applicationDocUrl }}{{ ApplicationNumber.Application_No }}/{{ doc.Doc_Path }}"
                  target="_blank"
                  [title]="doc.Doc_Path"
                  *ngIf="doc.Doc_Path"
                >
                  <span class="attachment-chip-text">{{
                    doc.Title || doc.Doc_Path
                  }}</span>
                </a>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="process-card"
      *ngIf="legalProcessCards && legalProcessCards.length > 0"
    >
      <div class="process-title">Legal Details</div>
      <div class="process-card-grid">
        <div
          class="process-record"
          *ngFor="let legal of legalProcessCards; let i = index"
        >
          <div class="process-record-head">#{{ i + 1 }}</div>
          <div class="process-grid">
            <div class="grid-item" *ngIf="legal['ValuationDate']">
              <div class="grid-sub-item">Legal Date :</div>
              <div class="grid-sub-item-value">{{ legal["ValuationDate"] }}</div>
            </div>
            <div class="grid-item" *ngIf="legal['Valuation_Type']">
              <div class="grid-sub-item">Legal Type :</div>
              <div class="grid-sub-item-value">{{ legal["Valuation_Type"] }}</div>
            </div>
            <div class="grid-item" *ngIf="legal['Valuation_Amount']">
              <div class="grid-sub-item">Legal Amount :</div>
              <div class="grid-sub-item-value">{{ legal["Valuation_Amount"] }}</div>
            </div>
            <div class="grid-item" *ngIf="legal['Valuation_Type2']">
              <div class="grid-sub-item">Legal Type 2 :</div>
              <div class="grid-sub-item-value">{{ legal["Valuation_Type2"] }}</div>
            </div>
            <div class="grid-item" *ngIf="legal['Valuation_Amount2']">
              <div class="grid-sub-item">Legal Amount 2 :</div>
              <div class="grid-sub-item-value">{{ legal["Valuation_Amount2"] }}</div>
            </div>
            <div class="grid-item" *ngIf="legal['ValuationDoneBy']">
              <div class="grid-sub-item">Legal Done By :</div>
              <div class="grid-sub-item-value">{{ legal["ValuationDoneBy"] }}</div>
            </div>
            <div class="grid-item process-remark" *ngIf="legal['Process_Remark']">
              <div class="grid-sub-item">Remark :</div>
              <div class="grid-sub-item-value">{{ legal["Process_Remark"] }}</div>
            </div>
          </div>

          <div
            class="process-attachments"
            *ngIf="legal.attachments && legal.attachments.length > 0"
          >
            <div class="process-attachments-title">Attachments</div>
            <div class="attachment-list">
              <ng-container *ngFor="let doc of legal.attachments">
                <a
                  class="attachment-chip"
                  href="{{ applicationDocUrl }}{{ ApplicationNumber.Application_No }}/{{ doc.Doc_Path }}"
                  target="_blank"
                  *ngIf="doc.Doc_Path"
                  [title]="doc.Doc_Path"
                >
                  <span class="attachment-chip-text">{{
                    doc.Title || doc.Doc_Path
                  }}</span>
                </a>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end: common valuation and legal details -->

</div>
